// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox_Checkbox__3KIv6","CheckboxLabel":"Checkbox_CheckboxLabel__3oXnQ","Switcher":"Checkbox_Switcher__9Leph","Switcher_active":"Checkbox_Switcher_active__cvogj"};